import Vue from 'vue'
import App from './App'
import router from './router/router'
import VueFlashMessage from '@smartweb/vue-flash-message';
import './assets/global.css';
import "bootstrap/dist/css/bootstrap.min.css";
import Multiselect from 'vue-multiselect'

Vue.config.productionTip = false

Vue.use(VueFlashMessage, {
  messageOptions: {
    timeout: 600000, // milliseconds
    important: true,
    // autoEmit: false,
    pauseOnInteract: true
  }
});

// register globally
Vue.component('multiselect', Multiselect)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')